import axios from "axios";
import { getSynchronizationErrorsFailed, getSynchronizationErrorsSuccess } from "./actions";
import { GET_SYNCHRONIZATION_ERRORS_WATCHER } from "./contants";
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../../utils/storage";
import { call, put, takeLatest } from "redux-saga/effects";

export function getSynchronizationErrorsApi(id) {
    return axios.request({
        method: "GET",
        headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
        url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/synchronization-errors/${id}`,
    })
}

export function* getSynchronizationErrorsSaga(action) {
    try {
      const { data, status } = yield call(
        getSynchronizationErrorsApi,
        action.payload
      )
  
      if (status === 200) {
        yield put(getSynchronizationErrorsSuccess(data))
      }
    } catch (e) {
      yield put(getSynchronizationErrorsFailed())
      console.error(e)
    }
}

export default function* synchronizationErrorsSaga() {
// See example in containers/HomePage/saga.js    
  yield takeLatest(GET_SYNCHRONIZATION_ERRORS_WATCHER, getSynchronizationErrorsSaga)
}
    